module.exports = __webpack_public_path__ + "static/media/nwg_logo_white.7870d948.svg";